import type React from 'react';

import { Text } from '@change/ds-core-ui';

import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { PetitionQRCode } from 'src/app/shared/components/qrcode';

import { PetitionQRCodeDownloadLink } from './components/PetitionQRCodeDownloadLink';

type PetitionQRCodeDownloadProps = {
	slugOrId: string;
	displaySize: number;
	displayType: QrCodeType;
	downloadType: QrCodeType;
	downloadSize: number;
	descriptionText: string;
	downloadLinkText: string;
	downloadFilename?: string;
	onClick?: () => Promise<void>;
};

export const PetitionQRCodeDownload: React.FC<PetitionQRCodeDownloadProps> = ({
	slugOrId,
	displaySize,
	displayType,
	downloadSize,
	downloadType,
	descriptionText,
	downloadLinkText,
	downloadFilename,
	onClick,
}) => {
	return (
		<div className="flex flex-row gap-4">
			<div className="shrink-0">
				<PetitionQRCode slugOrId={slugOrId} size={displaySize} type={displayType} />
			</div>
			<div className="flex flex-col gap-2">
				<Text>{descriptionText}</Text>
				<PetitionQRCodeDownloadLink
					slugOrId={slugOrId}
					size={downloadSize}
					type={downloadType}
					onClick={onClick}
					filename={downloadFilename}
				>
					{downloadLinkText}
				</PetitionQRCodeDownloadLink>
			</div>
		</div>
	);
};
